module.exports = __webpack_public_path__ + "static/media/bfile-disabled.eb28e274.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/bfile-disabled.svg
// module id = 973
// module chunks = 0